import { createAction, props } from '@ngrx/store';

export const routerNavigate = createAction('[Core] Navigate With Router', props<{ url: string }>());
